// removed by extract-text-webpack-plugin
module.exports = {"checkbox":"_1r090","checkboxLabel":"_2y7AK","couponCode":"_1J_4W","couponCodeTitle":"_2_IEs","couponCodeSubtitle":"_3UKq1","couponCodeMessage":"_7ni-g","couponCodeHelpText":"_1_tXj","couponCodeText":"_2XIci","helpText":"_17Mt1","input":"_2lgjc","invalid":"QgbSm","typing":"_10DVH","updateButton":"_3Z8c9"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/ShoppingCartContents/CouponCodeForm/index.sass
// module id = 1504
// module chunks = 1